import React from 'react'
import { format, formatDistanceToNow, formatDistance } from 'date-fns'

import Avatar from '../Avatar'
import ProgressIndicator from '../ProgressIndicator'
import TableTags from '../List/TableTags'
import BackgroundRenderer from './renderers/BackgroundRenderer'
import StatusRenderer from './renderers/StatusRenderer'
import ActionRenderer from './renderers/ActionRenderer'
import BarRenderer from '../GridList/renderers/BarRenderer'
import CountRenderer from './renderers/CountRenderer'
import AvatarTagsRenderer from './renderers/AvatarTagsRenderer'
import { truncate } from 'utils/common'

export const renderCell = (item, def, color, gridView = 'list') => {
  const getValue = def.customValue ? def.customValue(item[def.column]) : item[def.column]

  const safeTitle = (val) => (val === null || val === undefined || typeof val === 'boolean' ? undefined : String(val))

  switch (def.type) {
    case 'action':
      return <ActionRenderer color={color} onClick={def.onClick} column={item[def.column]} truncateLength={def.truncate} notFoundText={def.notFoundText} />
    case 'bar':
      return <BarRenderer color={color} onClick={item.onClick} column={item[def.column]} />
    case 'count':
      return <CountRenderer color={color} onClick={def.onClick} column={item[def.column]} truncateLength={def.truncate} prefix={def.prefix} def={def} gridView={gridView}/>
    case 'tags':
      return (
        <TableTags
          colorClassName={color}
          tags={def.subColumn ? item[def.column][def.subColumn] : item[def.column]}
          isPlain={def.isPlain}
          onClick={def.onClick}
          tagLength={def.tagLength}
          iconLength={def.tagLength}
          maxCount={def.tagLength}
          noWrap
        />
      )
    case 'timeElapse':
      return item[def.column] ? formatDistanceItem(formatDistanceToNow(new Date(item[def.column]), { addSuffix: true })) : '-'
    case 'timeEta':
      return item[def.column] ? formatDistanceItem(formatDistance(new Date(item[def.column]), new Date(), { addSuffix: true })) : '-'
    case 'avatar':
      return (
        item[def.column] && <Avatar
          color={color}
          firstName={item[def.column].firstName}
          lastName={item[def.column].lastName}
          showName
          truncateLength={def.truncate}
          onClick={(e) => {
            if(def.onClick) {
              e.stopPropagation()
              e.preventDefault()
              def.onClick(item[def.column])
            }
          }}
        />
      )
    case 'avatarTags':
      return (
        <AvatarTagsRenderer item={item} def={def} color={color} />
      )
    case 'status':
      return (
        <StatusRenderer color={color} name={getValue} colorMap={def.colorMap} def={def} isGrid />
      )
    case 'indicator':
      return (
        <ProgressIndicator value={item[def.column].value} total={item[def.column].total} />
      )
    case 'background':
      return (
        <BackgroundRenderer color={item[def.column].color} value={item[def.column].value} />
      )
    case 'dateTime':
      return format(new Date(item[def.column]), 'd MMM yyyy HH:mm')
    case 'capital':
      return <span className='type__value' title={safeTitle(item[def.column])}>{def.truncate ? truncate(item[def.column], def.truncate) : item[def.column]}</span>
    case 'uppercase':
      return <span className='text-uppercase' title={safeTitle(item[def.column])}>{def.truncate ? truncate(item[def.column], def.truncate) : item[def.column]}</span>
    default:
      if (item.isDefault && def.defaultText) {
        return <span title={safeTitle(getValue)}>{def.truncate ? truncate(getValue, def.truncate) : getValue}
          <span className={`workspace_owner_tag badge_tag_${color}`}>
            {def.defaultText}
          </span>
        </span>
      }

      return <span title={safeTitle(getValue)}>{def.truncate ? truncate(getValue, def.truncate) : getValue}</span>
  }
}

export const formatDistanceItem = (value, shorten = false) => {
  if (!value) return value

  if (!shorten) {
    return String(value).replace('about', '').replace('minutes', 'min')
  }

  let v = String(value).trim()
  const lower = v.toLowerCase()
  const isFuture = /^in\s/i.test(lower)
  v = v.replace(/^in\s+/i, '').replace(/\s+ago$/i, '').trim()
  v = v.replace(/\b(about|over|almost)\s+/gi, '')
  v = v.replace(/less than a minute/i, '<1m')
  v = v.replace(/\byears?\b/gi, 'y')
    .replace(/\bmonths?\b/gi, 'm')
    .replace(/\bweeks?\b/gi, 'w')
    .replace(/\bdays?\b/gi, 'd')
    .replace(/\bhours?\b/gi, 'h')
    .replace(/\bminutes?\b/gi, 'm')
    .replace(/\bseconds?\b/gi, 's')
  v = v.replace(/(\d+)\s*([a-z<>]+)\b/gi, '$1$2')
  return isFuture ? `in ${v}` : `${v} ago`
}

export const paginateData = (data, currentPage, itemsPerPage) => {
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage
  return data.slice(startIndex, endIndex)
}

export const manageColumnsData = (defs) =>
  defs.map(def => {
    return {
      ...def,
      sortKey: def.column,
      isSortable: !def.notSortable,
      isVisible: !def.isHidden
    }
  })